export default __webpack_public_path__ + "static/media/Clockwise.e52f04c1.png";